<div class="row no-margin">
  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <h3 class="headings">Bank Account Change History</h3>
  </div>
</div>
<div class="payment_bdy">
  <div class="table_content  mt-xl-3 mt-lg-3 mt-md-3" *ngIf="!showExport">
    <div class="row px-xl-4 px-lg-4 px-md-4 py-4">
      <div class="col-lg-4 col-xl-4 col-md-12 col-sm-12 col-12 form-group has-search mb-0">
        <span class="fa fa-search form-control-feedback"></span>
        <input type="search" class="form-control search-bar col-xl-12 col-lg-12 col-md-12 col-12 py-2"
               [(ngModel)]="searchText" (input)="searchHits.next()"
               placeholder="Search"/>
      </div>
      <div class="col-lg-7 col-xl-6 col-md-12 col-sm-9 col-8 mb-md-2 mob_calendar mb-xl-0 mb-lg-0">
        <div class="row">
          <input type="text" [(ngModel)]="from_date"
                 class="form-control calander-input-icon col-xl-4 col-md-5 col-md-5 col-md-5 col-4 ml-md-3 mr-xl-3 mr-m-7"
                 #dp="bsDatepicker" placement="bottom" [bsConfig]="bsDateConfig" [maxDate]="today" placeholder="From"
                 bsDatepicker [(bsValue)]="from_date" (bsValueChange)="checkdate();" (onHidden)="datereport();">
          <input type="text" [(ngModel)]="to_date"
                 class="form-control calander-input-icon col-xl-4 col-md-6 col-md-6 col-md-6 col-4 mob_text"
                 #dp1="bsDatepicker"
                 [bsConfig]="bsDateConfig" placement="bottom" placeholder="To" [maxDate]="today" bsDatepicker
                 [(bsValue)]="to_date" (bsValueChange)="checkdate2();" (onHidden)="datereport();">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 px-m-0">
        <div (scroll)='scrollcontent("TopScroll", "scrollContent")' *ngIf="!loadFlag" class="top-scroll" id="TopScroll">
          <img src="" height=1 [style]="checkTablewidth()">
        </div>
        <div class="table-responsive table-height" (scroll)='scrollcontent("scrollContent", "TopScroll")'
             id="scrollContent">
          <app-message-on-list *ngIf="!loadFlag && errorMsg" [message]="errorMsg"
                               [iconName]="'warning'"></app-message-on-list>
          <table *ngIf="!errorMsg" class="table mb-0" id="table-width">
            <thead>
            <tr>
              <th class="type">Requested by</th>
              <th class="date"><a (click)="setSorting('created_at')">Date
                <i class="fa fa-thin" [ngClass]="orderBy === 'created_at' ? stylesortBy : 'fa-angle-down'"></i>
              </a></th>
              <th class="used_for">Used for</th>
              <th class="status">Status</th>
              <th class="details">Details</th>
              <th class="rn">New RN</th>
              <th class="acct">New acct</th>
              <th class="rn">Old RN</th>
              <th class="acct">Old acct</th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngIf="loadFlag">
              <tr class="loader">
                <td colspan="7">
                  <div class="loader-container">
                    <img class="table-loader" src="../../../assets/images/loading.svg" />
                  </div>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="!loadFlag && changeRequestList.data.length > 0">
              <tr class="cus_list" *ngFor="let c_request of changeRequestList.data">
                <td class="type" data-th="RequestedBy">
                  <a [routerLink]="redirect_link" [queryParams]="{ id: c_request.id }"
                     [innerHTML]="highlight( c_request.requested_by_user_name)">
                  </a>
                </td>
                <td class="date" data-th="Date"
                    [title]="c_request.requested_at | dateonly:'MM/DD/yyyy'">
                  <a>{{ c_request.requested_at | dateonly:'MM/DD/yyyy' }}</a></td>
                <td class="used_for" data-th="Used for">
                  <a [routerLink]="redirect_link" [queryParams]="{id: c_request.id} "  [innerHTML]="highlight(c_request.used_for)">
                  </a>
                </td>
                <td class="status" data-th="Status">
                  <i class="fa fa-circle "
                     [ngClass]="['Review in progress', 'Pending'].includes(c_request.history_status)
                          ? 's_pending'
                          : ['Update completed'].includes(c_request.history_status)
                            ? 's_active'
                            : 's_canceled'"
                     aria-hidden="true"></i>
                  <a [routerLink]="redirect_link" [queryParams]="{id: c_request.id} "  [innerHTML]="highlight(c_request.history_status)">
                  </a>
                </td>
                <td class="details" data-th="Details">
                  <a (click)="reveal(c_request)">
                    <i class="fa fa-eye "></i></a>
                </td>
                <td class="rn" data-th="New RN">
                  <a [routerLink]="redirect_link" [queryParams]="{id: c_request.id} "  [innerHTML]="highlight(c_request.routing_number)">
                  </a>
                </td>
                <td class="acct" data-th="New acct">
                  <a [routerLink]="redirect_link" [queryParams]="{id: c_request.id} "  [innerHTML]="highlight(c_request.bank_account_number)">
                  </a>
                </td>
                <td class="rn" data-th="Old RN">
                  <a [routerLink]="redirect_link" [queryParams]="{id: c_request.id} "  [innerHTML]="highlight(c_request.old_routing_number)">
                  </a>
                </td>
                <td class="acct" data-th="Old acct">
                  <a [routerLink]="redirect_link" [queryParams]="{id: c_request.id} "  [innerHTML]="highlight(c_request.old_bank_account_number)">
                  </a>
                </td>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </div>
        <div class="row m-0 pt-sm-4 pt-2 border-2" *ngIf="!loadFlag && changeRequestList.data.length > 0">
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 mb-5" *ngIf="metadata['total']">
              <span class="paginate">
                {{ 1 + (metadata['current_page'] - 1) * limit }} -
                <select [(ngModel)]="limit" (change)="limitChange()" class="page-limit"
                        *ngIf="metadata['current_page'] === 1">
                  <option *ngFor="let no of limitArray" [value]="no">{{
                      no
                    }}</option>
                </select>
                <span *ngIf="metadata['current_page'] !== 1">{{
                    metadata['count'] +
                    (metadata['current_page'] - 1) * limit
                  }}</span> &nbsp;of &nbsp;{{ metadata['total'] }}
              </span>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 text-lg-right text-left px-m-0 px-md-m-0">
            <ul class="list-inline"  *ngIf="!loadFlag && changeRequestList.data.length > 0 && objectKeys(metadata.links).length > 0">
              <li  class="list-inline-item"><button type="button" class="btn btn-default btn_prenext" [disabled]="!metadata.links['previous']"
                                                    (click)="paginate( metadata.links['previous'])">
                <i class="fa fa-angle-double-left" aria-hidden="true"></i> Previous
              </button></li>
              <li class="list-inline-item" *ngFor="let number of numbers()">
                <div *ngIf="+number.toString() ">
                  <a class="page-link" *ngIf="metadata.links.next" [ngClass]="{ 'paginate_active': metadata['current_page'] === number }"
                     (click)="nextpage(number, metadata.links.next)" >{{number}}</a>
                  <a class="page-link" *ngIf="metadata.links['previous'] && metadata['current_page'] > (metadata['total_pages'] - 1)" [ngClass]="{ 'paginate_active': metadata['current_page'] === number }"
                     (click)="nextpage(number, metadata.links['previous'])" >{{number}}</a>
                </div>
                <a class="page-link" *ngIf="!+number.toString()" >{{number}}</a>
              </li>
              <li  class="list-inline-item" ><button type="button" class="btn btn-default btn_prenext" [disabled]="!metadata.links['next']"
                                                     (click)="
                  paginate(metadata.links['next']) ">
                Next  <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              </button></li>
            </ul>


          </div>
        </div>
      </div>
    </div>
</div>
</div>
